import { Box, Grid } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import range from 'lodash/range';
import { statics } from 'modules/common';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useCompanyBasedOnUrl } from 'shared/hooks';

import { CardControls } from '../CardControls/CardControls';
import { WalletCard } from '../WalletCard/WalletCard';
import { useWallets } from './WalletsTab.hooks';

export const WalletsTab = memo(() => {
    const company = useCompanyBasedOnUrl();

    const { wallets, isLoadingWallets, isLoadingWalletsBalances } = useWallets(company.id);

    return (
        <Grid gap={16} role='list' gridTemplateColumns='repeat(auto-fill, minmax(400px, 1fr))'>
            {isLoadingWallets
                ? range(3).map((index) => <WalletCard.Loading key={index} />)
                : wallets.map((item) => {
                      const {
                          isVisible,
                          isConvertible,
                          currency: { code: currencyCode },
                          balance,
                          IconFlag,
                      } = item;

                      if (!isVisible) {
                          return null;
                      }

                      return (
                          <WalletCard
                              key={item.id}
                              balance={
                                  isLoadingWalletsBalances ? <Skeleton /> : intl.formatCurrency(balance, currencyCode)
                              }
                              canConvert={isConvertible}
                              currencyCode={currencyCode}
                              currencyName={statics.currency.findCurrencyNameByCode(currencyCode) || ''}
                              controls={<CardControls currencyCode={currencyCode} wallet={item} />}
                              IconFlag={
                                  IconFlag ? (
                                      <IconFlag width='22px' height='16px' />
                                  ) : (
                                      <Box color='midnight40' width={22} height={16} />
                                  )
                              }
                          />
                      );
                  })}
        </Grid>
    );
});

WalletsTab.displayName = 'WalletsTab';
